import React, { useState } from "react";
import ClickAwayListener from "react-click-away-listener";
import { dontFireOnTouchEventOnTargetHandler } from "../Helpers/clickAwayListenerHelpers";

interface PricingLocationSelectLocationSelectProps<T> {
  availableLocations: T[];
  renderListItem: (item: T) => JSX.Element;
  selectLocationsLabel: string;
  currentLocationName: string;
}

export const PricingLocationSelect = <T,>({
  availableLocations,
  selectLocationsLabel,
  currentLocationName,
  renderListItem,
}: PricingLocationSelectLocationSelectProps<T>): JSX.Element => {
  const [showDropdown, setShowDropdown] = useState(false);
  const toggleDropdown = () => setShowDropdown(!showDropdown);
  const onClickAway = (e: Event) => {
    dontFireOnTouchEventOnTargetHandler(
      "button-location-filter",
      () => showDropdown && setShowDropdown(false),
      e
    );
  };

  return (
    <>
      <span className="label d-block" id="dropdownLabel">
        {selectLocationsLabel}
      </span>
      <button
        className="button-location-filter form-control form-select max-width text-truncate m-0"
        onClick={toggleDropdown}
        aria-haspopup="true"
        aria-expanded={showDropdown}
        aria-controls="multiselect-popup-container"
        aria-labelledby="dropdownLabel"
      >
        {currentLocationName}
      </button>

      <ClickAwayListener onClickAway={onClickAway}>
        <div id="multiselect-popup-container" aria-live="polite">
          {showDropdown && (
            <div className="multiselect-popup p-2 pb-0">
              <ul className="no-bullets m-0 p-0 list-columns one-col-lg">
                {availableLocations.map((location, id) => (
                  <li className="pb-1 pb-md-2" key={id} onClick={() => showDropdown && setShowDropdown(false)}>
                    {renderListItem(location)}
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      </ClickAwayListener>
    </>
  );
};
